import { FullPageReceipt } from './FullPageReceipt';
export default FullPageReceipt;